import React, { useContext, useEffect, useRef, useState } from 'react'
import { IoCameraOutline } from "react-icons/io5";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../App';
import axios from 'axios';
import { LoadingFull } from '../../loading';

const Conversation = ({selected, setSelected, chats, setChats, setChatsOpen, loadingChats}) => {
    
  const [msg, setMsg] = useState('');
  const chatBoxRef = useRef(null);
  const textareaRef = useRef(null);
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const { auth, user, unread_count } = useContext(UserContext)
  
  const handleBuy = () => {
    if (localStorage.getItem('basket') !== null) {
      if (!localStorage.getItem('basket').includes(selected.dbId)) {
          localStorage.setItem('basket', (localStorage.getItem('basket') ? localStorage.getItem('basket').split(',') : []).concat(selected.dbId).join(','))
      }
    } else {
      localStorage.setItem('basket', selected.dbId)
    }
    navigate(`/checkout`)
  }
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Hvis Enter er trykket uden Shift, send beskeden
      if (!e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    }
  };

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset højden
      textarea.style.height = `${textarea.scrollHeight}px`; // Sæt højden til scrollHeight
    }
  };

  useEffect(() => {
    adjustHeight(); // Juster højden, når beskeden ændres
  }, [msg]);
  
  useEffect(() => {
    if (chatBoxRef.current) {
      const chatBox = chatBoxRef.current;
      chatBox.scrollTop = chatBox.scrollHeight;
    }
  }, [chats, selected]);

  const sendMessage = () => {
    if (msg !== '') {
      const message = msg.replace(/\n/g, '\\n');
      setMsg('')
      setChats(prevChats => {
        const newList = [...prevChats]; // Lav en kopi af den tidligere liste
        const chat = newList.find(a => a.chatId === selected.chatId);
        if (chat) {
          chat.messages.push({'content': message, 'sender': user._id, 'sending': true})
        }
        return newList; // Returner den opdaterede liste
      });
      axios({
        method: 'post',
        url: '/api/chatSM',
        data: {
          'chat': selected,
          'msg': message
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        if (response.data.newChat) {
          setChats(prevChats => {
            const newList = [...prevChats]; // Lav en kopi af den tidligere liste
            const chat = newList.find(a => a.chatId === response.data.chat.chatId);
            if (chat) {
              chat.messages = response.data.chat.messages; // Opdater beskederne
            }
            return newList; // Returner den opdaterede liste
          });
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  return (
    <div className="conversation lg:flex-[1] border border-neutral-100 flex flex-col w-full absolute lg:static top-0 bottom-0 left-0 right-0">
      {(!loadingChats) ?
        (typeof selected !== 'undefined') ?
          <>
            <div className="p-5 text-center relative">
              <div className="absolute left-0 top-0 block lg:hidden mx-5 mt-5 flex gap-2 items-center w-fit cursor-pointer" onClick={() => setChatsOpen(true)}>
                <FaArrowLeftLong />
                {unread_count > 0 ? <div className="w-4 h-4 bg-emerald-600 rounded-full text-xs text-white text-center font-medium">{unread_count}</div> : ""}
                <p className="hidden md:block">Tilbage</p>
              </div>
              <h2 className="text-sm font-medium">{(selected.seller._id !== user._id) ? `${selected.seller.first_name} ${selected.seller.last_name}` : `${selected.buyer.first_name} ${selected.buyer.last_name}`}</h2>
            </div>
            <div className="product flex items-center justify-between p-5 border-t border-neutral-200">
                <div className="details flex items-center gap-5">
                  <div className="image w-12 h-12 md:w-20 md:h-20 aspect-square bg-neutral-100">
                      <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${selected.product.dbBook._id}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
                  </div>
                  <div className="details flex flex-col gap-1">
                      <h2 className="text-xs sm:text-base font-medium">{selected.product.apiBook.title}</h2>
                      <p className="text-xs sm:text-sm">{Number(selected.product.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                  </div>
                </div>
                <div className="hidden sm:block">
                  {(selected.product.dbBook.sold) ?
                    (selected.product.dbBook.ejer === user._id) ?
                        <div className="py-2 px-5 w-fit bg-emerald-600 text-white content-center cursor-pointer hover:bg-emerald-700" onClick={() => navigate(`/confirm/${selected.product.dbBook._id}`, { relative: 'path' })}>Se detaljer</div>
                    : (selected.product.dbBook.køber === user._id) ?
                        <div className="py-2 px-5 w-fit bg-emerald-600 text-white content-center cursor-pointer hover:bg-emerald-700" onClick={() => navigate(`/dashboard/bekræftelse?book=${selected.product.dbBook._id}`, { relative: 'path' })}>Se detaljer</div>
                    :
                        <div className="py-2 px-5 w-fit bg-gradient-to-r from-neutral-400 to-neutral-500 bg-pos-0 bg-size-200 text-white content-center select-none">Solgt</div>
                  :
                    (selected.product.dbBook.ejer === user._id) ?
                        <div className="py-2 px-5 w-fit ring-1 ring-emerald-600 content-center cursor-pointer hover:text-white hover:bg-emerald-600 transition-[]" onClick={() => navigate(`/dashboard/editBook?book=${selected.product.dbBook._id}`, { state: { data: selected.product }, relative: 'path' })}>Rediger</div>
                    :
                        <div className="py-2 px-5 w-fit bg-emerald-600 text-white content-center cursor-pointer hover:bg-emerald-700" onClick={() => handleBuy()}>Køb nu</div>}
                </div>
            </div>
            <div className="messages h-full flex flex-col gap-5 p-5 border-t border-neutral-200 overflow-y-auto" ref={chatBoxRef}>
              {selected.messages.map((msg) => {

                const messageDate = new Date(msg.created);
                const now = new Date();
                // Beregn datoen 7 dage før nu
                const sevenDaysAgo = new Date();
                sevenDaysAgo.setDate(now.getDate() - 7);
              
                // Formater output
                let formattedTime;
                if (messageDate.toDateString() === now.toDateString()) {
                  // Hvis beskeden er i dag, vis klokken
                  formattedTime = messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                } else if (messageDate >= sevenDaysAgo) {
                  // Hvis beskeden er mindre end 7 dage gammel, vis ugedagen kun hvis det ikke er den samme dag
                  if (messageDate.getDay() !== now.getDay()) {
                    formattedTime = messageDate.toLocaleDateString([], { weekday: 'short' });
                  } else {
                    // Hvis beskeden også er sendt på samme dag som nu, vis datoen
                    formattedTime = `d. ${messageDate.getDate()}. ${messageDate.toLocaleString('da-DK', { month: 'short' })}`;
                  }
                } else {
                  // Hvis beskeden også er sendt på samme dag som nu, vis datoen
                  formattedTime = `d. ${messageDate.getDate()}. ${messageDate.toLocaleString('da-DK', { month: 'short' })}`;
                }
                return (
                  msg.sender === user._id ?
                    <div class="flex items-start justify-end gap-2.5">
                      <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gradient-to-r from-emerald-600 to-emerald-700 bg-size-200 bg-pos-0 text-white rounded-s-xl rounded-br-xl">
                          <div class="flex items-center space-x-2 rtl:space-x-reverse">
                            <span class="text-sm font-semibold">Dig</span>
                            <span class="text-sm font-normal">{('sending' in msg) ? "" : formattedTime}</span>
                          </div>
                          <p class="text-sm font-normal py-2.5" dangerouslySetInnerHTML={{
                            __html: msg.content.replace(/\\n/g, "<br />"),
                          }}></p>
                          <span class="text-xs font-normal">{('sending' in msg) ? "Sender" : "Sendt"}</span>
                      </div>
                    </div>
                  :
                    <div class="flex items-start gap-2.5">
                      <div class="flex flex-col w-full max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl">
                          <div class="flex items-center space-x-2 rtl:space-x-reverse">
                            <span class="text-sm font-semibold text-gray-900">{(selected.seller._id !== user._id) ? selected.seller.first_name : selected.buyer.first_name}</span>
                            <span class="text-sm font-normal">{('sending' in msg) ? "" : formattedTime}</span>
                          </div>
                          <p class="text-sm font-normal py-2.5 text-gray-900" dangerouslySetInnerHTML={{
                            __html: msg.content.replace(/\\n/g, "<br />"),
                          }}></p>
                      </div>
                    </div>
                )
              })}
            </div>
            <div className="input flex flex-wrap items-center gap-x-5 gap-y-2 p-5 border-t border-neutral-200">
              {/*<div className="foto text-2xl cursor-pointer p-2 flex gap-2 items-center">
                <IoCameraOutline />
                <p className="block lg:hidden text-sm">Uploud et billede</p>
              </div>*/}
              <div className="flex flex-col h-full w-full gap-2">
                <div className="flex w-full">
                  <textarea ref={textareaRef} type="text" placeholder="Skriv en besked" rows="1" value={msg} onChange={(e) => setMsg(e.target.value)} onKeyDown={handleKeyDown} className="h-fit w-full p-5 bg-neutral-100 focus:outline-none max-h-48" />
                  <div className="h-full px-5 w-fit bg-emerald-600 text-white content-center cursor-pointer hover:bg-emerald-700" onClick={sendMessage}>Send</div>
                </div>
                <p className="text-neutral-400 text-xs hidden lg:block"><span className="font-semibold">Shift+Enter</span> for linjeskift</p>
              </div>
            </div>
          </>
        :
          <div className="w-full h-full justify-center flex items-center italic">Din samtale vises her</div>
      :
        <LoadingFull />}
    </div>
  )
}

export default Conversation